<script setup lang="ts">
import EditAuthDrawer from '@/pages/erp/ds/auth/view/ds-auth-drawer.vue'
import DsActionMember from "@/pages/erp/ds/menu/view/ds-action-member.vue";
import type { AuthProperties } from '@/pages/erp/ds/auth/db/ds-auth-types'
import Swal from 'sweetalert2'
import DsActionDialog from "@/pages/erp/ds/menu/view/ds-action-dialog.vue";
definePage({
})

interface Props {
  menuId?: string
  triggerSearch?: number
}

const props = defineProps<Props>()

const compId = ref(useStorage('compNo').value)
const authorityId = ref(props.menuId)

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '功能代號', key: 'action' },
    { title: '功能名稱', key: 'authorityDesc' },
    // { title: '可操作人員', key: 'operate', sortable: false},
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: authsData, execute: fetchAuths } = await useApi<any>(createUrl('/ds/auth/auth/searchAuth', {
  query: {
    compId,
    authorityId,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): AuthProperties[] => authsData.value.data.authPage.content)
const totalDatas = computed(() => authsData.value.data.authPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)

const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (authData: AuthProperties) => {
  voData = authData
  console.log('editAuth: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (authData: AuthProperties) => {
    voData = authData
    console.log('copyAuth: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (authData: AuthProperties) => {
  await $api('/ds/auth/auth/createAuth', {
    method: 'POST',
    body: { auth: authData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuths()
}

const updateData = async (authData: AuthProperties) => {
  await $api('/ds/auth/auth/updateAuth', {
    method: 'PUT',
    body: { auth: authData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuths()
}

  // 👉 Delete data
const deleteData = async (authData: AuthProperties) => {
  const { compId,authorityId,action } = authData
    $swal({
    title: `確定要刪除 ${authData.authorityId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/auth/deleteAuth`, {
        method: 'DELETE',
        query: {
          compId,authorityId,action
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchAuths()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}
const isEditActionMemberVisible = ref(false)

const editMenuId = ref()
const editActionId = ref()

const editActionMember = (menuId: string, actionId: string) => {
  console.log('editActionMember: ', menuId, actionId)
  editMenuId.value = menuId
  editActionId.value = actionId
  isEditActionMemberVisible.value = true
}

const isEditActionVisible = ref(false)
let actionData = {}


const editAuthData = (authData: AuthProperties) => {
  actionData = authData
  console.log('editAuthData: ', actionData)
  isEditActionVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const updateAuthData = async (authData: AuthProperties) => {
  await $api('/ds/auth/auth/updateAuth', {
    method: 'PUT',
    body: { auth: authData },
  }).then(() => {
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })
  // refetch Data
  fetchAuths()
}

watch(props, (val) => {
  fetchAuths()
})

</script>

<template>
  <VDataTableServer
    v-model:items-per-page="size"
    v-model:page="currentPage"
    :items="datas"
    :items-length="totalDatas"
    :headers="grid1Headers"
    density="compact"
    class="text-no-wrap"
    @update:options="updateOptions"
  >

    <template #item.action="{ item }">
      <div class="text-body-1 text-high-emphasis">
        {{ item.action }}
      </div>
    </template>

    <template #item.authorityDesc="{ item }">
      <div class="text-body-1 text-high-emphasis">
        {{ item.authorityDesc }}
      </div>
    </template>

    <!-- Actions -->
    <template #item.operate="{ item }">
      <IconBtn @click="editActionMember(item.authorityId, item.action)">
        <VIcon icon="tabler-user-plus" />
        <v-tooltip
          activator="parent"
          location="bottom"
        >新增可操作人員</v-tooltip>
      </IconBtn>
    </template>

    <!-- Actions -->
    <template #item.actions="{ item }">
      <VBtn
        variant="outlined"
        density="compact"
        @click.stop="editAuthData(item)"
        style="margin-right: 10px;"
      >
        編輯
      </VBtn>
      <VBtn
        variant="outlined"
        density="compact"
        @click.stop="editActionMember(item.authorityId, item.action)"
        style="margin-right: 10px;"
      >
        授權人員
      </VBtn>
      <VBtn
        variant="outlined"
        density="compact"
        @click.stop="deleteData(item)"
        style="margin-right: 10px;"
      >
        刪除
      </VBtn>
    </template>

    <!-- pagination -->
    <template #bottom>
<!--      <TablePagination-->
<!--        v-model:page="currentPage"-->
<!--        v-model:size="size"-->
<!--        :items-per-page="size"-->
<!--        :total-items="totalDatas"-->
<!--      />-->
    </template>
  </VDataTableServer>
  <!-- 👉 Edit -->
  <EditAuthDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :auth-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

  <DsActionMember
    v-if="isEditActionMemberVisible"
    v-model:isDialogVisible="isEditActionMemberVisible"
    :menu-id="editMenuId"
    :action-id="editActionId"
  />

  <DsActionDialog
    v-if="isEditActionVisible"
    v-model:isDialogVisible="isEditActionVisible"
    :authority-id="authorityId"
    :auth-data="actionData"
    :is-new="isNewData"
    :is-copy="isCopyData"
    @update-data="updateAuthData"
  />

</template>
